import { Link } from 'react-router-dom'

import APP from 'app'

import './Footer.css'

const Footer = () => (
  <footer className="MainFooter">
    <div className="body-content">
      <div className="social">
        <a className="ui circular mini facebook icon button" href="https://fb.com/SweatBits" target="fb">
          <i className="facebook large icon" />
        </a>
        <a className="ui circular mini twitter icon button" href="https://twitter.com/SweatBits" target="tw">
          <i className="twitter large icon" />
        </a>
        <a className="ui circular mini instagram icon button" href="https://instagram.com/SweatBits" target="in">
          <i className="instagram large icon" />
        </a>
        <a
          className="ui circular mini youtube icon button"
          href="https://youtube.com/channel/UCjhe7djc9AI-RJyQqelKMZQ"
          target="yo"
        >
          <i className="youtube large icon" />
        </a>
      </div>
      <br />
      <br />
      <Link className="logo" to="/">
        <img alt="SweatBits" src={`${APP.url}/img/sweatbits-text.png`} />
      </Link>
      <br />
      <br />
      Copyright &copy; 2017 - SweatBits
    </div>
  </footer>
)

Footer.displayName = 'Footer'

export default Footer
